// 공지사항 API(계약 §8, 대표 전용). X-Admin-Id 는 공통 클라이언트가 붙이고, 작성자는 서버가 그 값으로 넣는다.
import { http, data, errorText, fileUrl } from "../../inquiry/v6Api";

export { errorText, fileUrl };

// 서버 상한 100 — 응답은 배열(전체 건수는 /summary)
export const PAGE = 100;

export async function listNotices({ status = "all", q = "", offset = 0 } = {}) {
    const params = { status, ...(q && q.trim() ? { q: q.trim() } : {}), offset, limit: PAGE };
    const rows = await data(http.get("/notices/", { params }));
    return Array.isArray(rows) ? rows : [];
}
export const getNoticeSummary = () => data(http.get("/notices/summary"));
export const createNotice = (body) => data(http.post("/notices/", body));
export const updateNotice = (id, body) => data(http.patch(`/notices/${id}`, body));
export const deleteNotice = (id) => http.delete(`/notices/${id}`);

export async function uploadNoticeImage(file) {
    const form = new FormData();
    form.append("file", file);
    const r = await data(http.post("/notices/images", form));
    return r.url;
}
